
import jsPDF from 'jspdf';
import { AnalysisSection } from '@/components/personality/enhanced-analysis/types';
import { PDF_CONFIG, CATEGORY_COLORS, CATEGORY_TITLES } from './constants';
import { cleanContentForPDF, wrapText, checkNewPage } from './formatters';

export const generateSectionContent = (
  pdf: jsPDF,
  sections: AnalysisSection[],
  pageWidth: number,
  pageHeight: number,
  margin: number,
  startYPosition: number
): void => {
  const contentWidth = pageWidth - (margin * 2);
  let yPosition = startYPosition;

  // Group sections by category
  const categorizedSections: Record<string, AnalysisSection[]> = {
    overview: [],
    traits: [],
    psychology: [],
    clinical: [],
    recommendations: []
  };

  sections.forEach(section => {
    if (categorizedSections[section.category]) {
      categorizedSections[section.category].push(section);
    } else {
      categorizedSections.overview.push(section);
    }
  });

  // Add sections by category
  Object.entries(categorizedSections).forEach(([category, categorySections]) => {
    if (categorySections.length === 0) return;

    // Category header
    const { newYPosition: newY1 } = checkNewPage(pdf, yPosition, 30, pageHeight, margin);
    yPosition = newY1;
    
    const categoryColor = CATEGORY_COLORS[category] || CATEGORY_COLORS.overview;
    
    pdf.setFillColor(...categoryColor);
    pdf.rect(margin, yPosition, contentWidth, 15, 'F');
    
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(PDF_CONFIG.fonts.sizes.categoryTitle);
    pdf.setFont('helvetica', 'bold');
    pdf.text(CATEGORY_TITLES[category as keyof typeof CATEGORY_TITLES] || 'ANÁLISE', margin + 5, yPosition + 10);
    
    yPosition += 25;

    // Add sections in this category
    categorySections.forEach((section, index) => {
      // Section title
      const { newYPosition: newY2 } = checkNewPage(pdf, yPosition, 20, pageHeight, margin);
      yPosition = newY2;
      
      pdf.setTextColor(...categoryColor);
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      const sectionTitle = `${index + 1}. ${section.title}`;
      pdf.text(sectionTitle, margin, yPosition);
      yPosition += 8;

      // Section content
      pdf.setTextColor(31, 41, 55); // Gray-800 color as RGB values
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      
      // Clean and format content
      const cleanedContent = cleanContentForPDF(section.content || 'Conteúdo não disponível');
      const wrappedContent = wrapText(pdf, cleanedContent, contentWidth, 9);
      
      // Check if content fits on current page
      const contentHeight = wrappedContent.length * 3.5;
      const { newYPosition: newY3 } = checkNewPage(pdf, yPosition, contentHeight + 10, pageHeight, margin);
      yPosition = newY3;
      
      pdf.text(wrappedContent, margin, yPosition);
      yPosition += contentHeight + 15;
    });

    yPosition += 10; // Extra space between categories
  });
};
